import * as React from 'react'
import { ImageStyle, StyleProp, TouchableOpacity, View, ViewStyle } from 'react-native'
import { CommunityImageSearchResource } from '~api/types'
import { useTheme } from '~theme/ThemeManager'
import CacheableImage from './CacheableImage'

export type CommunityImageSearchItemProps = {
  item: CommunityImageSearchResource
  width: number
  onPress: () => void
}

export function CommunityImageSearchItem(props: CommunityImageSearchItemProps): React.JSX.Element {
  const { theme } = useTheme()
  const { item, width, ...rest } = props

  const aspect = React.useMemo(() => {
    const aspectRatio = item.width / item.height
    return { height: (width - 24) / aspectRatio, width: width - 24 }
  }, [item.height, item.width, width])

  const containerStyle: StyleProp<ViewStyle> = {
    width: aspect.width,
    height: aspect.height,
    marginBottom: 12,
  }

  const imageStyle: StyleProp<ImageStyle> = {
    width: aspect.width,
    height: aspect.height,
    borderWidth: 1,
    borderColor: theme[100],
  }

  return (
    <View style={containerStyle}>
      <TouchableOpacity {...rest}>
        <CacheableImage source={{ uri: item.thumbnail }} style={imageStyle} contentFit="contain" />
      </TouchableOpacity>
    </View>
  )
}
